export const actionTypes = {
    GET_ITEM: 'GET_ITEM',
}

export const initialState = {
    item: {},
}

export function reducer(state, action) {
    switch (action.type) {
        case actionTypes.GET_ITEM:
            const { item } = action.payload
            return {
                ...state,
                item,
            }
        default:
            throw Error(`action type not allowed: ${action.type}`)
    }
}